import { render, staticRenderFns } from "./DiscountInput.vue?vue&type=template&id=1239d7d5&"
import script from "./DiscountInput.vue?vue&type=script&lang=js&"
export * from "./DiscountInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DiscountInput.vue"
export default component.exports